import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../services/http-service.service';

@Component({
  selector: 'app-email-verify',
  imports: [RouterLink],
  templateUrl: './email-verify.component.html',
  styleUrl: './email-verify.component.css'
})
export class EmailVerifyComponent implements OnInit , OnDestroy{
  private token : string = '';
  private emailVerifySubsscription?: Subscription;
  private queryParamsSubscription?: Subscription;
  emailVerified : boolean = false;
  invalidEmail : boolean = false;
  constructor(private route: ActivatedRoute, private httpService : HttpServiceService) { }

  ngOnInit(): void {
    this.emailVerified = false;
    this.invalidEmail = false;
    this.queryParamsSubscription = this.route.paramMap.subscribe(params => {
      this.token = params.get('token') ?? "";
      this.emailVerifySubsscription = this.httpService.verifyEmail({token : this.token}).subscribe({
        next : (resp) => {
          this.emailVerified = true;
        },
        error : (error) => {
          this.invalidEmail = true;
        }
      })
    });    
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription?.unsubscribe();
    this.emailVerifySubsscription?.unsubscribe();
  }
}
